import React, { Component } from 'react';

import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ManagePin from '../myprofile/managepin.jsx'

class NavChangePin extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }} >
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable
                            pauseOnHover
                        />
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 10px", minHeight: "476px" }}>
                                <h4>Change PIN</h4>
                                <ManagePin />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavChangePin;


// WEBPACK FOOTER //
// ./src/components/navchangepin/navchangepin.jsx